import { SettingsState } from './model'
import { ActionType, SettingsActions } from './actions'

const initialState: SettingsState = <SettingsState> {
  selectedEnrichedCategory: undefined,
  cloudhub: {
    selectedEnvironment: null
  },
  hybrid: {
    selectedEnvironment: null
  }
}

const reducer = (state: SettingsState = initialState, action: SettingsActions): SettingsState => {
  switch (action.type) {

    case ActionType.ChangeCategory:
      return {...state, selectedEnrichedCategory: action.payload.category}

    case ActionType.ChangeEnvironment:
      switch (action.payload.category.url) {
        case 'cloudhub':
          const cloudhubCategory = {selectedEnvironment: action.payload.environmentId}
          return {...state, cloudhub: cloudhubCategory}
        case 'hybrid':
          const hybridCategory = {selectedEnvironment: action.payload.environmentId}
          return {...state, hybrid: hybridCategory}

        default:
          return state
      }

    default:
      return state
  }
}

export default reducer
